import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgKoppelConflict = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={17}
    height={17}
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M0.122039 15.9572C-0.0406796 16.1199 -0.0406796 16.3837 0.122039 16.5464C0.284757 16.7091 0.548576 16.7091 0.711295 16.5464L8.50756 8.75H12.0833C12.3135 8.75 12.5 8.56345 12.5 8.33333C12.5 8.10321 12.3135 7.91667 12.0833 7.91667H9.34088L12.2575 5H12.5C14.3409 5 15.8333 6.49238 15.8333 8.33333C15.8333 10.1743 14.3409 11.6667 12.5 11.6667H10.4167C10.1865 11.6667 10 11.8532 10 12.0833C10 12.3135 10.1865 12.5 10.4167 12.5H12.5C14.8012 12.5 16.6667 10.6345 16.6667 8.33333C16.6667 6.22007 15.0934 4.47425 13.0543 4.20321L16.5461 0.711294C16.7088 0.548576 16.7088 0.284757 16.5461 0.122039C16.3834 -0.0406797 16.1196 -0.0406795 15.9569 0.122039L0.122039 15.9572Z'
      fill='#0A3680'
    />
    <path
      d='M4.16667 8.33333C4.16667 8.56345 4.35321 8.75 4.58333 8.75H6.15354L6.98685 7.91667H4.58333C4.35321 7.91667 4.16667 8.10321 4.16667 8.33333Z'
      fill='#0A3680'
    />
    <path
      d='M3.3402 11.5634L2.67759 12.226C1.11181 11.6267 0 10.1099 0 8.33333C0 6.03215 1.86548 4.16667 4.16667 4.16667H6.25C6.48012 4.16667 6.66667 4.35321 6.66667 4.58333C6.66667 4.81345 6.48012 5 6.25 5H4.16667C2.32572 5 0.833333 6.49238 0.833333 8.33333C0.833333 9.889 1.89903 11.1958 3.3402 11.5634Z'
      fill='#0A3680'
    />
  </svg>
);
export default SvgKoppelConflict;
